import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Comment out old directory imports to avoid build errors
// import OldPilotLogin from './components/old/PilotLogin';
import CloudSamplePilotLogin from './components/cloud-sample-PilotLogin';
// Removed AlternatePilotLogin import
import CloudSamplePilotDashboard from './components/cloud-sample-PilotDashboard';
import PilotDashboard from './components/PilotDashboard';
// Removed AlternatePilotDashboard import
import PilotLogin from './components/PilotLogin';
import NewPilotLogin from './components/NewPilotLogin';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { isAuthenticated } from './utils/auth';
import './App.css';

// Create a theme
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2196f3', // DJI blue color
      light: '#64b5f6',
      dark: '#1976d2',
    },
    secondary: {
      main: '#f5222d', // DJI red color
      light: '#ff5c5c',
      dark: '#d32f2f',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
    },
    h2: {
      fontWeight: 500,
    },
    h3: {
      fontWeight: 500,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 4,
  },
});

// Protected route wrapper with improved debugging
const ProtectedRoute = ({ children }) => {
  useEffect(() => {
    console.log('ProtectedRoute rendered, checking auth with auth utility...');
  }, []);

  // Check if we're on a cloud sample route using hash
  const isCloudSampleRoute = window.location.hash.includes('cloud-sample');
  const loginPath = isCloudSampleRoute ? "/cloud-sample-login" : "/login";
  
  if (!isAuthenticated()) {
    console.log('Not authenticated, redirecting to login:', loginPath);
    return <Navigate to={loginPath} replace />;
  }
  
  console.log('Authentication successful, rendering protected content');
  return children;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Routes>
            {/* Legacy routes kept for backward compatibility */}
            {/* <Route path="/old-pilot-login" element={<OldPilotLogin />} /> */}
            {/* <Route path="/old-dashboard" element={
              <ProtectedRoute>
                <StandardPilotDashboard />
              </ProtectedRoute>
            } /> */}
            <Route path="/cloud-sample-login" element={<CloudSamplePilotLogin />} />
            <Route path="/cloud-sample-dashboard" element={
              <ProtectedRoute>
                <CloudSamplePilotDashboard />
              </ProtectedRoute>
            } />
            {/* Removed alternate-login route */}
            {/* Removed alternate-dashboard routes */}
            
            {/* New simplified login at root */}
            <Route path="/" element={<NewPilotLogin />} />
            <Route path="/login" element={<NewPilotLogin />} />

            {/* Old login preserved at /pilot-login */}
            <Route path="/pilot-login" element={<PilotLogin />} />

            {/* Dashboard routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <PilotDashboard />
              </ProtectedRoute>
            } />
            <Route path="/pilot-dashboard" element={
              <ProtectedRoute>
                <PilotDashboard />
              </ProtectedRoute>
            } />
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App; 